import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const CalculatorIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <rect
      height='18'
      rx='2'
      width='16'
      x='4'
      y='3'
    />
    <rect
      height='2'
      rx='1'
      width='8'
      x='8'
      y='7'
    />
    <path d='M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01M16 17h.01' />
  </Icon>
);

export default CalculatorIcon;
